export const REGION: string = process.env.REACT_APP_REGION as string;
export const USER_POOL_ID: string = process.env
  .REACT_APP_USER_POOL_ID as string;
export const USER_POOL_CLIENT_ID: string = process.env
  .REACT_APP_USER_POOL_CLIENT_ID as string;
export const QUALITYGATE_URL: string = process.env
  .REACT_APP_QUALITYGATE_URL as string;
export const LOGIN_URL: string = process.env.REACT_APP_LOGIN_URL as string;
export const VAULT_GATEWAY_URL: string = process.env
  .REACT_APP_VAULT_GATEWAY_URL as string;